// custom js

// Google Analytics code

window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config', 'UA-153837677-1');

  // Google tag manager code

  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-W3PMLRW');

// main menu hover 

jQuery( "li.menu-item" ).hover(function() { 
  jQuery( this ).find( " > .sub-menu" ).show();

}, function(){
  if ( !jQuery(this).hasClass("current_page_item") ) {
    jQuery( this ).find( ".sub-menu" ).hide();
  }
});

// projects page, add unique id to each button

jQuery('.projects-grid .button').each(function(i){
    jQuery(this).attr('id', 'modal-' + i);
});

//projects page, add unique id to url bar (desktop only)

if (jQuery(window).width() > 1039) {

  jQuery('.projects-grid .button').click(function(e) {
      window.location.hash = jQuery(this).attr('id');
      e.preventDefault();
  });

// close modal on back button click (desktop only)

  window.onpopstate = function() {
     jQuery('.page-id-988 .reveal-overlay').css('display', 'none');
  }; history.pushState({}, '');

}

// add unique ids to each button on projects page

jQuery('.projects-modal').each(function(i){
    jQuery(this).attr('id', 'modal' + i);
});

jQuery('.services-content .entry-content .button').each(function(i){
    jQuery(this).attr('data-open', 'modal' + i);
});

// Main menu animation on page load 

jQuery(window).load(function() {
  jQuery("header .top-bar .top-bar-right ul li.active a").addClass("trigger");
});

// stop/play videos on hover

if ( jQuery('body').hasClass('home')) {

  //video ids

  var videoOne = document.getElementById('video-one');
  var videoTwo = document.getElementById('video-two');
  var videoThree = document.getElementById('video-three');
  var videoFour = document.getElementById('video-four');
  var videoFive = document.getElementById('video-five');

  // video arrays

  var arrayOne = [videoTwo, videoThree, videoFour, videoFive];
  var arrayTwo = [videoOne, videoThree, videoFour, videoFive];
  var arrayThree = [videoOne, videoTwo, videoFour, videoFive];
  var arrayFour = [videoOne, videoTwo, videoThree, videoFive];
  var arrayFive = [videoOne, videoTwo, videoThree, videoFour];

  //hovers

  var figureOne = jQuery("#video-grid .video-holder.box-one").hover( hoverVideoOne, hideVideoOne );
  var figureTwo = jQuery("#video-grid .video-holder.box-two").hover( hoverVideoTwo, hideVideoTwo );
  var figureThree = jQuery("#video-grid .video-holder.box-three").hover( hoverVideoThree, hideVideoThree );
  var figureFour = jQuery("#video-grid .video-holder.box-four").hover( hoverVideoFour, hideVideoFour );
  var figureFive = jQuery("#video-grid .video-holder.box-five").hover( hoverVideoFive, hideVideoFive );

  // video hover 
  function hoverVideoOne(e) { 
    videoOne.playbackRate = 1;
      jQuery('video', this).get(0).play();
      jQuery('video', this).attr('loop', true);
      jQuery.each(arrayOne, function(i){
        jQuery(this)[0].currentTime = 0;
        jQuery(this).get(0).pause();
      });
  };

  //video-one
  function hideVideoOne(e) {
    jQuery('video', this)[0].currentTime = 0;
    jQuery('video', this).get(0).pause();
    jQuery('video', this).removeAttr('loop', true);
    var randomItemOne = arrayOne[Math.floor(Math.random()*arrayOne.length)];
    randomItemOne.playbackRate = 3;
    jQuery(randomItemOne).get(0).play();
  };

  //video-two
  function hoverVideoTwo(e) { 
    videoTwo.playbackRate = 1;
      jQuery('video', this).get(0).play();
      jQuery('video', this).attr('loop', true);
      jQuery.each(arrayTwo, function(i){
        jQuery(this)[0].currentTime = 0;
        jQuery(this).get(0).pause();
      });
  };

  function hideVideoTwo(e) {
    jQuery('video', this)[0].currentTime = 0;
    jQuery('video', this).get(0).pause();
    jQuery('video', this).removeAttr('loop', true);
    var randomItemTwo = arrayTwo[Math.floor(Math.random()*arrayTwo.length)];
    randomItemTwo.playbackRate = 3;
    jQuery(randomItemTwo).get(0).play();
  };

  //video-three
  function hoverVideoThree(e) { 
    videoThree.playbackRate = 1;
      jQuery('video', this).get(0).play();
      jQuery('video', this).attr('loop', true);
      jQuery.each(arrayThree, function(i){
        jQuery(this)[0].currentTime = 0;
        jQuery(this).get(0).pause();
      });
  };

  function hideVideoThree(e) {
    jQuery('video', this)[0].currentTime = 0;
    jQuery('video', this).get(0).pause();
    jQuery('video', this).removeAttr('loop', true);
    var randomItemThree = arrayThree[Math.floor(Math.random()*arrayThree.length)];
    randomItemThree.playbackRate = 3;
    jQuery(randomItemThree).get(0).play();
  };

  //video-four
  function hoverVideoFour(e) { 
    videoFour.playbackRate = 1;
      jQuery('video', this).get(0).play();
      jQuery('video', this).attr('loop', true);
      jQuery.each(arrayFour, function(i){
        jQuery(this)[0].currentTime = 0;
        jQuery(this).get(0).pause();
      });
  };

  function hideVideoFour(e) {
    jQuery('video', this)[0].currentTime = 0;
    jQuery('video', this).get(0).pause();
    jQuery('video', this).removeAttr('loop', true);
    var randomItemFour = arrayFour[Math.floor(Math.random()*arrayFour.length)];
    randomItemFour.playbackRate = 3;
    jQuery(randomItemFour).get(0).play();
  };

  //video-five
  function hoverVideoFive(e) { 
    videoFive.playbackRate = 1;
      jQuery('video', this).get(0).play();
      jQuery('video', this).attr('loop', true);
      jQuery.each(arrayFive, function(i){
        jQuery(this)[0].currentTime = 0;
        jQuery(this).get(0).pause();
      });
  };

  function hideVideoFive(e) {
    jQuery('video', this)[0].currentTime = 0;
    jQuery('video', this).get(0).pause();
    jQuery('video', this).removeAttr('loop', true);
    var randomItemFive = arrayFive[Math.floor(Math.random()*arrayFive.length)];
    randomItemFive.playbackRate = 3;
    jQuery(randomItemFive).get(0).play();
  };

  // trigger video loop

  // play video two is at the end of this file

  jQuery('#video-two').on('ended', function() {
    videoTwo.currentTime = 0;
    var randomTwo = arrayTwo[Math.floor(Math.random()*arrayTwo.length)];
    randomTwo.playbackRate = 3;
    jQuery(randomTwo).get(0).play();
  });

  jQuery('#video-four').on('ended', function() {
    videoFour.currentTime = 0;
    var randomFour = arrayFour[Math.floor(Math.random()*arrayFour.length)];
    randomFour.playbackRate = 3;
    jQuery(randomFour).get(0).play();
  });

  jQuery('#video-one').on('ended', function() {
    videoOne.currentTime = 0;
    var randomOne = arrayOne[Math.floor(Math.random()*arrayOne.length)];
    randomOne.playbackRate = 3;
    jQuery(randomOne).get(0).play();
  });

  jQuery('#video-three').on('ended', function() {
    videoThree.currentTime = 0;
    var randomThree = arrayThree[Math.floor(Math.random()*arrayThree.length)];
    randomThree.playbackRate = 3;
    jQuery(randomThree).get(0).play();
  });

  jQuery('#video-five').on('ended', function() {
    videoFive.currentTime = 0;
    var randomFive = arrayFive[Math.floor(Math.random()*arrayFive.length)];
    randomFive.playbackRate = 3;
    jQuery(randomFive).get(0).play();
  });

  videoTwo.playbackRate = 3;
  document.getElementById('video-two').play();

};

// trigger video loop

/*document.getElementById('video-two').play();

videoTwo.addEventListener("timeupdate", function(){
    if (videoTwo.currentTime >= 2) {
    	this.pause();
        this.load();
        jQuery('#video-four').get(0).play();
    }
});

videoFour.addEventListener("timeupdate", function(){
    if (videoFour.currentTime >= 2) {
        this.load();
        jQuery('#video-one').get(0).play();
    }
});

videoOne.addEventListener("timeupdate", function(){
    if (videoOne.currentTime >= 2) {
        this.load();
        jQuery('#video-three').get(0).play();
    }
});

videoThree.addEventListener("timeupdate", function(){
    if (videoThree.currentTime >= 2) {
        this.load();
        jQuery('#video-five').get(0).play();
    }
});

videoFive.addEventListener("timeupdate", function(){
    if (videoFive.currentTime >= 2) {
        this.load();
        jQuery('#video-two').get(0).play();
    }
});*/

/*jQuery('#video-two').on('ended', function() {
	videoTwo.currentTime = 0;
	jQuery('#video-four').get(0).play();
	videoFour.addEventListener("timeupdate", function(){
	    if(videoFour.currentTime >= 2) {
	        this.load();
	    }
	});
});*/

/*jQuery('#video-four').on('ended', function() {
	videoFour.currentTime = 0;
	jQuery('#video-one').get(0).play();
});*/

/*jQuery('#video-one').on('ended', function() {
	videoOne.currentTime = 0;
	jQuery('#video-three').get(0).play();
});

jQuery('#video-three').on('ended', function() {
	videoThree.currentTime = 0;
	jQuery('#video-five').get(0).play();
});

jQuery('#video-five').on('ended', function() {
	videoFive.currentTime = 0;
	jQuery('#video-two').get(0).play();
});*/


// trim text and load more

/*var textOne = jQuery(".case-studies .content-cell-1 p");

if(textOne.text().length>200){
    jQuery.data(document.body,"content-cell-1",textOne.text());
    textOne.text(textOne.text().substr(0,200)+"...");
} else {
   jQuery("#read-more-1").remove(); 
}

jQuery("#read-more-1").click(function(){
    textOne.text(jQuery.data(document.body,"content-cell-1"));
    jQuery("#read-more-1").remove(); 
});

var textTwo = jQuery(".case-studies .content-cell-2 p");

if(textTwo.text().length>200){
    jQuery.data(document.body,"content-cell-2",textTwo.text());
    textTwo.text(textTwo.text().substr(0,200)+"...");
} else {
   jQuery("#read-more-2").remove(); 
}

jQuery("#read-more-2").click(function(){
    textTwo.text(jQuery.data(document.body,"content-cell-2"));
    jQuery("#read-more-2").remove(); 
});

var textThree = jQuery(".case-studies .content-cell-3 p");

if(textThree.text().length>200){
    jQuery.data(document.body,"content-cell-3",textThree.text());
    textThree.text(textThree.text().substr(0,200)+"...");
} else {
   jQuery("#read-more-3").remove(); 
}

jQuery("#read-more-3").click(function(){
    textThree.text(jQuery.data(document.body,"content-cell-3"));
    jQuery("#read-more-3").remove(); 
});*/


//loading gif for video

jQuery(window).load(function() {
    jQuery(".loader").fadeOut("fast");
});

// object fit IE fix for video

objectFitVideos();

//hamburger menu

var navButton = jQuery("[data=hamburger-menu]");
var navLink = jQuery("[data=hamburger-link]");

navButton.click( function() {
  jQuery(this).toggleClass("active");
});

//trigger animation if link in menu is clicked

navLink.click( function() {
  jQuery('.nav-button').toggleClass("active");
});

////////// SLIDEOUT MENU /////////

/// Adapted from: http://bit.ly/2zw2P5s

var toggleBool = false;

jQuery('.nav-btn a.nav-button').click(function (){
  if(toggleBool == false){
    menuAnimIn(jQuery('.mobile-menu'),  0);
    toggleBool = true;
  } else {
    menuAnimIn(jQuery('.mobile-menu'), jQuery(window).height());
    toggleBool = false;
  }
  jQuery('.mobile-menu').toggleClass('active');
});

function menuAnimIn(obj, fromTop) {
      jQuery(obj).velocity({
            bottom: fromTop
      }, {
            easing: 'ease-in-out',
            //complete: function(elements) { checkBool() }
      })
}

//about page carousel

jQuery('.home-slider').slick({
  dots: false,
  infinite: true,
  fade: true,
  cssEase: 'linear',
  speed: 300,
  slidesToShow: 1,
  //slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

jQuery('#slider').slickLightbox({
	caption: 'caption'
});

// testimonials page slider 

//about page carousel

jQuery('.testimonials').slick({
  dots: false,
  infinite: true,
  fade: false,
  cssEase: 'linear',
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 8000,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

//add class to last item in list on news page

jQuery('.news-grid').last().addClass('no-border');

// add classes to video posts

jQuery(".news-item").each(function(i) {
    jQuery(this).addClass("news-video-"+(i+1));
});

var videoCount = document.querySelectorAll('.image-holder').length;

jQuery(".image-holder").each(function(i) {
    jQuery(this).addClass("video-item-"+(i+1));
});

// play/pause videos in new page modals

jQuery('.video-item-1 button').on("click", function() {
  jQuery('#news-video.news-video-1')[0].play();
});

jQuery('.news-reveal .close-button').on('click', function() {
  jQuery('#news-video.news-video-1')[0].pause();
});

jQuery('.video-item-2 button').on("click", function() {
  jQuery('#news-video.news-video-2')[0].play();
});

jQuery('.news-reveal .close-button').on('click', function() {
  jQuery('#news-video.news-video-2')[0].pause();
});

jQuery('.video-item-3 button').on("click", function() {
  jQuery('#news-video.news-video-2')[0].play();
});

jQuery('.news-reveal .close-button').on('click', function() {
  jQuery('#news-video.news-video-3')[0].pause();
});

jQuery('.video-item-4 button').on("click", function() {
  jQuery('#news-video.news-video-2')[0].play();
});

jQuery('.news-reveal .close-button').on('click', function() {
  jQuery('#news-video.news-video-4')[0].pause();
});

jQuery('.video-item-5 button').on("click", function() {
  jQuery('#news-video.news-video-2')[0].play();
});

jQuery('.news-reveal .close-button').on('click', function() {
  jQuery('#news-video.news-video-5')[0].pause();
});


//var videos = document.querySelectorAll('.news-reveal [id^="news-video-"]');
//console.log(videos);


jQuery('button[id^="button-"]').each(function (index, value) {
  console.log('.button' + index + ':' + jQuery(this).attr('id'));
});


// read more function

//jQuery('.case-studies a.read-more').click(function (){
//  jQuery('.case-studies .hidden-text').slideToggle('fast');
//  jQuery('.case-studies .trim-text').toggle();
//});